module.exports = "<footer class=\"footer\">\n  <div class=\"container-fluid\">\n    <div class=\"col-xs-12 col-sm-6\">\n      <a href=\"http://www.miitbeian.gov.cn/\">苏ICP备16067181号</a>\n    </div>\n    <div class=\"col-xs-12 col-sm-6\">\n      <p>\n        <span class=\"glyphicon glyphicon-envelope\"></span> <a href=\"mailto:shiawan.co@gmail.com?subject=反馈\">shiawan.co@gmail.com</a>\n      </p>\n    </div>\n  </div>\n</footer>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/com/footer/footer.com.html
// module id = ./src/app/com/footer/footer.com.html
// module chunks = main